import { useCallback, useState } from "react";
import { useShallow } from "zustand/react/shallow";
import ViolationFloatingButton from "@/pages/roster-create/components/ViolationFloating";
import ViolationsFloatingMenu from "./ViolationsFloatingMenu";
import { useRosterViolationFilter } from "@/hooks/roster/useRosterViolationFilter";
import type {
  ValidateListType,
  ValidationPhase,
} from "@/hooks/useRosterValidation.ts";
import useStore from "@/store/store";
import type { ViolationToggleState } from "./RosterMadeTable";

type RosterViolationFloatingControlsProps = {
  rawValidateList?: ValidateListType | null;
  isValidating?: boolean;
  phase?: ValidationPhase;
  hideManpowerToggle?: boolean;
  violationState?: ViolationToggleState;
};

/**
 * `RosterMadeTable`과 동일한 위반 필터·토글 소스로 플로팅 버튼·메뉴만 렌더한다.
 * 테이블 내부 플로팅을 끌 때(`hideViolationFloating`) 상위에서 함께 배치한다.
 */
export function RosterViolationFloatingControls({
  rawValidateList,
  isValidating = false,
  phase = "idle",
  hideManpowerToggle = false,
  violationState,
}: RosterViolationFloatingControlsProps) {
  const [isFloatingMenuOpen, setIsFloatingMenuOpen] = useState(false);

  const handleToggleFloatingMenu = useCallback(() => {
    setIsFloatingMenuOpen((prev) => !prev);
  }, []);

  const handleCloseFloatingMenu = useCallback(() => {
    setIsFloatingMenuOpen(false);
  }, []);

  const violationStateFromStore = useStore(
    useShallow((s) => ({
      showManpowerViolations: s.showManpowerViolations,
      showConfigViolations: s.showConfigViolations,
    }))
  );
  const src = violationState ?? violationStateFromStore;
  const showManpowerViolations = src.showManpowerViolations ?? false;
  const showConfigViolations = src.showConfigViolations ?? false;

  const { validateList, filteredViolationCount } = useRosterViolationFilter({
    rawValidateList,
    showManpowerViolations,
    showConfigViolations,
  });

  return (
    <>
      <ViolationFloatingButton
        isValidating={isValidating}
        violationCount={filteredViolationCount}
        phase={phase}
        onClick={handleToggleFloatingMenu}
      />

      <ViolationsFloatingMenu
        validateList={validateList}
        isValidating={isValidating}
        phase={phase}
        hideManpowerToggle={hideManpowerToggle}
        isOpen={isFloatingMenuOpen}
        onClose={handleCloseFloatingMenu}
      />
    </>
  );
}
